let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8SmOL")).then(() => parcelRequire('7hqY2'));